import { Injectable } from '@angular/core';
import { where } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { PartnerNote } from '../models/partner-note.model';
import { IService } from '../models/service.interface';
import { FirestoreService } from './firestore.service';

const itemCollection = 'partner-notes';

@Injectable({
  providedIn: 'root',
})
export class PartnerNotesService implements IService<PartnerNote> {

  constructor(private firestore: FirestoreService) { }

  async save(note: PartnerNote) {
    return this.firestore.save(itemCollection, note);
  }

  async update(item: PartnerNote) {
    return this.firestore.update(itemCollection, item);
  }

  async updateOnly(guid: string, value: object) {
    return this.firestore.updateOnly(itemCollection, guid, value);
  }

  async delete(item: PartnerNote) {
    return this.firestore.delete(itemCollection, item);
  }

  get(guid: string): Observable<PartnerNote> {
    return this.firestore.get<PartnerNote>(itemCollection, guid);
  }

  getList(options?: { user?: string; users?: string[]; status?: string; contractor?: string }): Observable<PartnerNote[]> {
    const queryConstraints = [];
    if (options?.user) {
      queryConstraints.push(where('inviter', '==', options.user));
    }
    if (options?.users) {
      queryConstraints.push(where('inviter', 'in', options.users));
    }
    if (options?.status) {
      queryConstraints.push(where('status', '==', options.status));
    }
    if (options?.contractor) {
      queryConstraints.push(where('contractor', '==', options.contractor));
    }

    return this.firestore
      .getList<PartnerNote>(itemCollection, undefined, queryConstraints);
  }
}
